<div style="position: relative; height: 60px;">
  <button type="button" class="close btn-closed" aria-label="Close" (click)="decline()">
    <span aria-hidden="true" style="font-size: 50px; font-weight: 100;color: black">&times;</span>
  </button>
</div>

<div class="d-flex flex-column py-4" style="position: relative;" [ngStyle]="{'align-items': data.message ? 'center' : '',
                                                                                  'padding-left': data.message ? '' : '1.5em'}">

  <span *ngIf="data.message">
    <h1 class="mt-3 pr-2" mat-dialog-title style="font-family: 'Rubik', serif;font-size: 14px; text-align: start; line-height: 1; font-weight: 300; max-width: 200px;">{{message || this.data.message}}</h1>
  </span>

  <ng-container *ngIf="associatePax">

  </ng-container>

  <ng-container *ngIf="paymentData.length > 0">
    <h2 class="mt-3 text-confirm-payment">Presione SI para registrar su pago en el sistema</h2>

    <h3 class="mt-2 text-title-payment">Detalle de pago</h3>
    <div *ngFor="let payment of paymentData" style="position: relative">
      <div *ngIf="payment.id === 1" class="d-flex justify-content-between mb-1 text-payment">
        <div>
          Blickoins
        </div>
        <div>
          {{currencyItinerary}} {{payment.amount | number: '1.2-2'}}
        </div>
      </div>
      <div *ngIf="payment.id === 2" class="d-flex justify-content-between mb-1 text-payment">
        <div>
          Tarjeta de Crédito *
        </div>
        <div>
          {{currencyItinerary}} {{payment.amount | number: '1.2-2'}}
        </div>
        <div *ngIf="feePayment > 0" style="width: 11rem; font-size: 12px;">
        (Fee de productos {{currencyItinerary}} {{feePayment | number: '1.2-2'}})
        </div>
      </div>

      <div *ngIf="payment.id === 3" class="d-flex justify-content-between mb-1 text-payment">
        <div>
          Deposito en Garantía
        </div>
        <div>
          {{currencyItinerary}} {{payment.amount | number: '1.2-2'}}
        </div>
      </div>
      <div *ngIf="payment.id === 4" class="d-flex justify-content-between mb-1 text-payment">
        <div>
          Transferencia
        </div>
        <div>
          {{currencyItinerary}} {{payment.amount | number: '1.2-2'}}
        </div>
      </div>
      <!-- Fee bancario estimado del método (lo calcula y registra el backend) -->
      <div *ngIf="getBankFee(payment.id) as bankFee" class="d-flex justify-content-between mb-2 text-bank-fee">
        <div>Fee bancario ({{bankFee.percentage | number: '1.0-2'}}%)</div>
        <div>+ {{currencyItinerary}} {{bankFee.surcharge | number: '1.2-2'}}</div>
      </div>
    </div>

    <div *ngIf="bankFeeTotal > 0" class="d-flex justify-content-between mt-2 pt-2 text-payment text-total-transaction">
      <div>Total transacción</div>
      <div>{{currencyItinerary}} {{bankFees?.totals?.total | number: '1.2-2'}}</div>
    </div>
    <p *ngIf="bankFeeTotal > 0" class="text-bank-fee-note mb-0">Incluye fee bancario estimado {{currencyItinerary}} {{bankFeeTotal | number: '1.2-2'}}.</p>

  </ng-container>

  <ng-container *ngFor="let payment of paymentData">
    <div *ngIf="payment.id === 2" >
      <p class="text-disclaimer-payment-card">* Su pago por tarjeta ya fue aprobado por la entidad bancaria, este paso registrará el pago en el sistema</p>
    </div>
  </ng-container>

  <div *ngIf="data?.profile === 'seller'">
    <form [formGroup]="_formSelectAgency">
      <div class="d-flex flex-column">
        <select
                name="agencyId"
                id="agencyId"
                class="form-control input-search-box"
                formControlName="agencyId"
                (change)="changeAgency($event.target.value);"
        >
            <ng-container *ngFor="let agency of agencies">
              <option [value]="agency.id">{{agency.name}}</option>
            </ng-container>
        </select>
      </div>
    </form>
  </div>

  <div *ngIf="data?.profile === 'seller'" class="row d-flex justify-content-start mt-5" style="margin-left: 0em;">
      <button type="button" class="btn btn-sm btn-cancel " style=" width: 105px;" (click)="decline()">Salir</button>
      <button type="button"  data-placement="bottom" class="btn ml-3 btn-sm  shadow  btn-ok" [ngStyle]="{'background-color':  clientSetting?.clients_setting_global?.color_main_3, 'color': buttonTextActive}" style=" width: 105px;" title="Yes" (click)="confirm()">Continuar</button>
  </div>

  <div *ngIf="!data?.profile && !showCopyButton" class="row d-flex mt-3" [ngStyle]="{'justify-content': data.insurancePlan ? 'center' : 'start'}" style="margin-left: 0em;">
      <button type="button" class="btn btn-sm btn-cancel " style=" width: 105px;" (click)="decline()">No</button>
      <button type="button"  data-placement="bottom" class="btn ml-3 btn-sm  shadow btn-ok"  [ngStyle]="{'background-color':  clientSetting?.clients_setting_global?.color_main_3, 'color': buttonTextActive}" style=" width: 105px;" title="Yes" (click)="confirm()">Si</button>
  </div>

  <div *ngIf="showCopyButton && !data?.profile" class="d-flex flex-column mt-3">
    <div class="d-flex align-items-center mb-2">
      <button
        type="button"
        class="btn btn-sm btn-copy mr-3 d-flex w-100 align-items-center justify-content-center"
        style="width: 150px; gap: 10px; outline: none;"
        [ngStyle]="{'color': '#225B28'}"
        (click)="copyToClipboard()">
        <i class="fas" [class.fa-copy]="!copySuccess" [class.fa-check]="copySuccess"></i>
        {{ copySuccess ? 'copiado!' : 'copiar búsqueda' }}
      </button>
    </div>
    <div class="d-flex">
      <button type="button" class="btn btn-sm btn-cancel " style=" width: 105px;" (click)="decline()">No</button>
      <button type="button"  data-placement="bottom" class="btn ml-3 btn-sm  shadow btn-ok"  [ngStyle]="{'background-color':  clientSetting?.clients_setting_global?.color_main_3, 'color': buttonTextActive}" style=" width: 105px;" title="Yes" (click)="confirm()">Si</button>
    </div>
  </div>

</div>